module.exports = __webpack_public_path__ + "static/media/Monday_Step3_Image16.ee2261d9.webp";